var _ellipse, _ellipse2, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path2, _path3, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _circle, _rect18, _rect19, _circle2, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgScheduleAndTimeIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 200,
    fill: "none",
    viewBox: "0 0 308 200",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.651,
    cy: 82.646,
    fill: "#C2E7FB",
    rx: 4.651,
    ry: 4.646
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.362,
    cy: 158.354,
    fill: "#C2E7FB",
    rx: 4.362,
    ry: 4.354
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#5CB4F4",
    strokeWidth: 3,
    d: "M72.46 157.965c0 3.567-2.898 6.465-6.48 6.465-3.581 0-6.48-2.898-6.48-6.465 0-3.568 2.899-6.465 6.48-6.465 3.582 0 6.48 2.897 6.48 6.465z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.325,
    height: 6.392,
    fill: "#008AED",
    rx: 1.162,
    transform: "rotate(-44.944 54.325 -70.958)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.325,
    height: 6.392,
    fill: "#008AED",
    rx: 1.162,
    transform: "rotate(-44.944 70.827 -77.822)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.325,
    height: 6.392,
    fill: "#008AED",
    rx: 1.162,
    transform: "rotate(44.978 20.773 104.857)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.325,
    height: 6.392,
    fill: "#008AED",
    rx: 1.162,
    transform: "rotate(44.944 4.255 98.075)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.395,
    height: 6.154,
    x: 238.176,
    y: 56,
    fill: "#008AED",
    rx: 1.197
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2.395,
    height: 6.154,
    x: 238.176,
    y: 66.57,
    fill: "#008AED",
    rx: 1.197
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 2.238,
    height: 6.586,
    x: 248.605,
    y: 63.448,
    fill: "#008AED",
    rx: 1.119,
    transform: "rotate(90 248.605 63.448)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 2.238,
    height: 6.586,
    x: 236.586,
    y: 63.448,
    fill: "#008AED",
    rx: 1.119,
    transform: "rotate(90 236.586 63.448)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBF6FE",
    stroke: "#C1CBD6",
    strokeWidth: 2,
    d: "M95 73.5h105.25v77.25c0 2.209-1.791 4-4 4H99c-2.21 0-4-1.791-4-4V73.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEFF5",
    stroke: "#C1CBD6",
    strokeWidth: 2,
    d: "M99 46.5h97.25c2.209 0 4 1.79 4 4V73H95V50.5c0-2.21 1.79-4 4-4z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 8.5,
    height: 19,
    x: 112.25,
    y: 39,
    fill: "#DDE3EB",
    stroke: "#C1CBD6",
    strokeWidth: 2,
    rx: 4.25
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 8.5,
    height: 19,
    x: 175.25,
    y: 39,
    fill: "#DDE3EB",
    stroke: "#C1CBD6",
    strokeWidth: 2,
    rx: 4.25
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 129.25,
    y: 84.5,
    fill: "#C2E7FB",
    rx: 4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 106.75,
    y: 107,
    fill: "#008AED",
    rx: 4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 106.75,
    y: 128.75,
    fill: "#C2E7FB",
    rx: 4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 151,
    y: 84.5,
    fill: "#C2E7FB",
    rx: 4
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 128.5,
    y: 107,
    fill: "#C2E7FB",
    rx: 4
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 151,
    y: 107,
    fill: "#C2E7FB",
    rx: 4
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 128.5,
    y: 128.75,
    fill: "#C2E7FB",
    rx: 4
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 151,
    y: 128.75,
    fill: "#C2E7FB",
    rx: 4
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 172.75,
    y: 84.5,
    fill: "#C2E7FB",
    rx: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 187,
    cy: 140,
    r: 24.5,
    fill: "#EBEFF5",
    stroke: "#C1CBD6",
    strokeWidth: 3
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 16,
    x: 187,
    y: 123,
    fill: "#8799A8",
    rx: 1.5
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 16,
    x: 187.314,
    y: 140,
    fill: "#8799A8",
    rx: 1.5,
    transform: "rotate(45 187.314 140)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 140,
    r: 4,
    fill: "#8799A8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6EFFC",
    fillRule: "evenodd",
    d: "M112.915 118.25c-.173 0-.338-.071-.456-.197l-3.039-3.237c-.237-.251-.224-.647.027-.883.252-.236.648-.224.883.028l2.578 2.744 5.255-5.751c.234-.256.629-.273.884-.04.254.232.272.628.039.882l-5.71 6.25c-.117.129-.283.203-.457.204h-.004z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgScheduleAndTimeIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/schedule_and_time_icon.238ef89c.svg";
export { ForwardRef as ReactComponent };